import { render, staticRenderFns } from "./PedidoGerarPdf.vue?vue&type=template&id=f446f5be"
import script from "./PedidoGerarPdf.vue?vue&type=script&lang=js"
export * from "./PedidoGerarPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports